import moment from "moment";

export const MapToFilter = (values = {},keyName="name", valueName = "value")=>{

    return Object.entries(values).reduce((acc,[name,value])=>{
        if(value && value !== "") {
            if (typeof (value) === 'string') {
                value = value.trim();
            }
            debugger;
            switch (name){
                case "timestamp":
                case "requested_on":{
                    const [from, to] = value
                    return [...acc, {[keyName]:name, [valueName]: moment(from).utc().set({hour:0,minute:0,second:0,millisecond:0}), comparator: '>='},{[keyName]: name, [valueName]: moment(to).utc().set({hour:23,minute:59,second:59,millisecond:999}), comparator: '<='}]
                }
                case "from_timestamp":
                    return [...acc, {[keyName]: 'timestamp', [valueName]: moment(value).utc().set({hour:0,minute:0,second:0,millisecond:0}), comparator: '>='}]
                case "to_timestamp":
                    return [...acc, {[keyName] : 'timestamp', [valueName]: moment(value).utc().set({hour:23,minute:59,second:59,millisecond:999}), comparator: '<='}]
                case "s10_code":
                    return [...acc, {[keyName] : 's10_code_list', [valueName]: value, comparator: '@>'}]
                case "schema_list":
                    return [...acc, {[keyName] : 'schema_list', [valueName]: value, comparator: '@>'}]
                case "full_name":
                    return [...acc, {[keyName]: 'full_name',[valueName]: value, comparator: 'contains'}]
                case "em_name":
                    return [...acc, {[keyName]: 'em_name',[valueName]: value, comparator: 'contains'}]
                case "time_logged":{
                    const [from, to] = value
                    return [...acc, {[keyName]: name, [valueName]: moment(from).utc().set({hour:0,minute:0,second:0,millisecond:0}), comparator: '>='},{[keyName]:name, [valueName]: moment(to).utc().set({hour:23,minute:59,second:59,millisecond:999}), comparator: '<='}]
                }
                case "date_of_payment":{
                    const [from, to] = value
                    return [...acc, {[keyName]: name, [valueName]: moment(from).utc().set({hour:0,minute:0,second:0,millisecond:0}), comparator: '>='},{[keyName]:name, [valueName]: moment(to).utc().set({hour:23,minute:59,second:59,millisecond:999}), comparator: '<='}]
                }
                case "subject":
                    return [...acc, {[keyName]: 'subject',[valueName]: value, comparator: 'contains'}]
                case "message":
                    return [...acc, {[keyName]: 'message',[valueName]: value, comparator: 'contains'}]
                case "sent_date":{
                    const [from, to] = value
                    return [...acc, {[keyName]: 'sent_date', [valueName]: moment(from).utc().set({hour:0,minute:0,second:0,millisecond:0}), comparator: '>='},{[keyName]:'sent_date', [valueName]: moment(to).utc().set({hour:23,minute:59,second:59,millisecond:999}), comparator: '<='}]
                }
                case "available_schemes":
                    return [...acc, {[keyName]: 'available_schemes', [valueName]: value, comparator: '@>'}]
                case "zero_vat_reports":
                    if(value.length > 0){
                        return [...acc, {[keyName]: 'total_vat_due', [valueName]: value, comparator: 'isNull'}]
                    }
                    else {
                        return [...acc]
                    }
                case "invoice_payment_status":
                    if(value === 'no_invoice_found') {
                        return [...acc, {[keyName]: 'invoice_payment_status', [valueName]: value, comparator: 'isNull'}]
                    }
                    else {
                        return [...acc, {[keyName]: name, [valueName]: value}]
                    }
                case "started": {
                    console.log(value);
                    const [from, to] = value
                    return [...acc, {[keyName]: name, [valueName]: moment(from).utc().set({hour:0,minute:0,second:0,millisecond:0}), comparator: '>='},{[keyName]:name, [valueName]: moment(to).utc().set({hour:23,minute:59,second:59,millisecond:999}), comparator: '<='}]
                }
                case "context":
                    return [...acc, {[keyName]: ["full_name", "trade_name", "nominated_person", "nominated_email", "tin_number", "ioss_registry_non_union_scheme_id", "ioss_registry_union_scheme_id", "ioss_registry_import_scheme_id", "official_site_url", "nominated_person_secondary", "nominated_email_secondary"], [valueName]: `${value}`, comparator: 'in'}]
                default:
                    return [...acc, {[keyName]: name, [valueName]: value}]
            }
        } else {
            return acc;
        }
    }, [])
}
